import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './grid-form-input.css'

const GridFormInput = ({ field, id }) => (
  <input id={id} styleName="input" type="text" {...field} />
)

GridFormInput.propTypes = {
  field: PropTypes.object,
  id: PropTypes.string,
}

export default CSSModules(GridFormInput, styles)



/** WEBPACK FOOTER **
 ** ./src/components/grid-form-input/grid-form-input.js
 **/